import { Bg } from './styles'

export default function Background({ children }) {
    return (
        <Bg>
            {children}
        </Bg>
    )
}